/* eslint-disable react/prop-types */
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import dayjs from "dayjs";

/**
 * Presentational date checkboxes for invite/review flows (no API calls).
 * `dates` — ISO date strings the worker can work.
 */
export default function WorkerDateCheckboxes({
  dates = [],
  selectedDates = [],
  onToggleDate,
  disabled = false,
  idPrefix = "date",
}) {
  if (!dates.length) {
    return <span className="text-muted small">No available dates</span>;
  }

  return (
    <Row className="g-2">
      {dates.map((raw) => {
        const iso = typeof raw === "string" ? raw : raw?.date;
        if (!iso) return null;
        const checked = selectedDates.includes(iso);
        const id = `${idPrefix}-${iso}`;
        return (
          <Col xs="12" sm="6" md="4" key={iso}>
            <FormGroup check className="mb-0">
              <Input
                type="checkbox"
                id={id}
                checked={checked}
                disabled={disabled}
                onChange={() => onToggleDate?.(iso)}
              />
              <Label check htmlFor={id} className="mb-0 small">
                {dayjs(iso).format("DD MMM YYYY (ddd)")}
              </Label>
            </FormGroup>
          </Col>
        );
      })}
    </Row>
  );
}
